module.exports = __webpack_public_path__ + "static/main-fa807ea57ce13ccd861154bbba392d72.jpg";